import React from 'react';
import { Route, useNavigate, Navigate, useLocation } from 'react-router-dom';
import { store } from 'reducers/createStore';
import PropTypes from "prop-types";

// Redux
import { useSelector } from 'react-redux';

export const RouteLoggedIn = ({ children, roles, ...rest }) => {
    let navigate = useNavigate();
    // const authentication = store.getState().authentication;
    const authentication = useSelector(state => state.authentication)
    const location = useLocation();

    if (!authentication.userIsLoggedIn) {
        // not logged in so redirect to login page with the return url
        return <Navigate to={{ pathname: '/loggain'}} replace state={{ from: location, originError: 'notAuthenticated' }} />
    }
    // check if route is restricted by role
    if (roles && roles.indexOf(authentication.userType) === -1) {
        // role not authorised so redirect to home page
        return <Navigate to={{ pathname: '/loggain'}} replace state={{ from: location, originError: 'invalidRole' }} />
    }
    // authorised so return component
    return children
    
    // return (
    //     <Route {...rest} render={props => {
    //         if (!authentication.userIsLoggedIn) {
    //             // not logged in so redirect to login page with the return url
    //             return <Navigate to={{ pathname: '/loggain'}} replace state={{ from: location }} />
    //         }

    //         // check if route is restricted by role
    //         if (roles && roles.indexOf(authentication.userType) === -1) {
    //             // role not authorised so redirect to home page
    //             return <Navigate to={{ pathname: '/loggain'}} replace state={{ from: location }} />
    //         }

    //         // authorised so return component
    //         return <Component {...props} />
    //     }} />
    // );
};

RouteLoggedIn.propTypes = {
    component: PropTypes.object,
    roles: PropTypes.array,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
  }